var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTumblrDesktopShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1.911 0c3.764 1.39 11.266 5.724 13.94 6.868.674.367 1.149.66 1.149 1.632 0 .898-.705 1.214-1.254 1.558C13.013 11.718 3.081 16.602 1.911 17 0 17 .413 16.514 0 14.976.552 11.906 3.44 8.5 3.44 8.5S.19 3.083 0 2.024v-.205C.01.925.138 0 1.912 0m.113 1.807 3.238 5.367 4.451 1.014v.606l-4.451 1.212-3.238 5.06 13.074-6.572z"
})));
export default SvgTumblrDesktopShare;